enum EntityStatus {
  ACTIVE = "Active",
  ARCHIVED = "Archived",
  SUSPENDED = "Suspended",
  PROBATION = "Probation",
}

export default EntityStatus;
